module.exports = __webpack_public_path__ + "img/05_1.6596387a.png";